import { 
  Card, 
  CardHeader, 
  CardBody, 
  Heading, 
  VStack, 
  Divider
} from '@chakra-ui/react';
import { TimeRangeButton } from '../TimeRangeButton';

export interface KeyMoment {
  start: number;
  end: number;
  context: string;
}

interface KeyMomentsProps {
  moments: KeyMoment[];
}

export const KeyMoments = ({ moments }: KeyMomentsProps) => {
  // Ensure moments is an array
  const safeMoments = moments || [];
  
  if (safeMoments.length === 0) return null;
  
  return (
    <Card variant="outline">
      <CardHeader pb={2}>
        <Heading size="md">Key Moments</Heading>
      </CardHeader>
      <CardBody>
        <VStack spacing={4} align="stretch" divider={<Divider />}>
          {safeMoments.map((moment, index) => (
            <TimeRangeButton
              key={index}
              start={moment.start}
              end={moment.end}
              description={moment.context}
              data-testid="key-moment-item"
            />
          ))}
        </VStack>
      </CardBody>
    </Card>
  );
}; 